const $doc = $(document);
const $win = $(window);

$doc.on('click', '.js-filter .bc-sf-filter-block-title', function() {
  const $this = $(this);
  const $filter = $this.closest('.js-filter');
  const $block = $this.closest('.bc-sf-filter-option-block');
  const blockTitle = $block.data('title');

  $block
    .toggleClass('expanded')
    .removeClass('not-transition')
    .siblings()
    .removeClass('expanded');

  if ($block.hasClass('expanded')) {
    $filter
      .addClass('active')
      .attr('data-filter-dropdown', blockTitle);
  } else {
    $filter
      .removeClass('active')
      .attr('data-filter-dropdown', blockTitle);
  }
});

$doc.on('click touchstart', function(e) {
  const $target = $(e.target);

  if (!$target.hasClass('bc-sf-filter-option-block') && !$target.closest('.bc-sf-filter-option-block').length && !$target.hasClass('js-radio-filtered')) {
    $('.bc-sf-filter-option-block')
      .removeClass('expanded')
      .removeClass('not-transition');
    $('.js-filter').removeClass('active');
  }
});

$win.on('load resize', function() {
  const $collectionButtons = $('.js-collection-buttons');
  if ($collectionButtons.length) {
    const collectionButtonsHeight = $collectionButtons.outerHeight();

    $('.footer').css('padding-bottom', collectionButtonsHeight);
  };
});



// WEBPACK FOOTER //
// ../assets/js/filter.js